let catalog_links = document.querySelectorAll('.raa-catalog-link');

catalog_links.forEach(catalog_link => {
  catalog_link.addEventListener('mouseover', (event) => {
    if (event.target.matches('.raa-catalog-link')) {
      let link_id = catalog_link.id.slice(5);
      let content_panel = document.getElementById('content-' + link_id);
      let current_content_panel = document.querySelector(".raa-catalog-visible");
      current_content_panel.classList.remove("raa-catalog-visible");
      current_content_panel.classList.add("raa-catalog-hidden");
      current_content_panel.setAttribute('aria-hidden', 'true');
      content_panel.classList.remove("raa-catalog-hidden");
      content_panel.classList.add("raa-catalog-visible");
      content_panel.setAttribute('aria-hidden', 'false');
    }
  });
});
